import { useState, useEffect } from 'react';
import { Image } from '@/components/common/image';
import article2x from '@/assets/article-icon/2x/article.png';
import article3x from '@/assets/article-icon/3x/article.png';

interface ArticleIconProps {
  className?: string;
  width?: number;
  height?: number;
  alt?: string;
}

export function ArticleIcon({
  className,
  alt = "Article Icon"
}: ArticleIconProps) {
  const [devicePixelRatio, setDevicePixelRatio] = useState(1);

  useEffect(() => {
    // 获取设备像素比
    setDevicePixelRatio(window.devicePixelRatio || 1);

    // 监听设备像素比变化（比如用户缩放页面）
    const handlePixelRatioChange = () => {
      setDevicePixelRatio(window.devicePixelRatio || 1);
    };

    // 使用 matchMedia 监听像素比变化
    const mediaQuery = window.matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`);
    mediaQuery.addEventListener('change', handlePixelRatioChange);

    return () => {
      mediaQuery.removeEventListener('change', handlePixelRatioChange);
    };
  }, []);

  // 根据设备像素比选择合适的图像
  const getImageSrc = () => {
    if (devicePixelRatio >= 2) {
      return article3x;
    } else {
      return article2x;
    }
  };

  // 生成 srcSet 用于响应式图像
  const srcSet = `
    ${article2x} 1x,
    ${article3x} 2x,
  `;

  return (
    <Image
      src={getImageSrc()}
      srcSet={srcSet}
      alt={alt}
      className={className}
    />
  );
}

export const displayName = "Article Icon";